import isEqual from 'lodash/isEqual';
import mapValues from 'lodash/mapValues';
import pickBy from 'lodash/pickBy';
import omitBy from 'lodash/omitBy';
const isScalar = (unknown) => typeof unknown !== 'object';
const BREAKPOINT_ORDER = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
export const collapseBreakpoints = (breakpoints) => {
    const [firstBreakpointLabel, ...restBreakpointsLabels] = BREAKPOINT_ORDER.filter((breakpoint) => Boolean(breakpoints[breakpoint]));
    const firstValue = breakpoints[firstBreakpointLabel];
    const { collapsedBreakpoints } = restBreakpointsLabels.reduce((acc, currentBreakpointLabel) => {
        const currentValue = breakpoints[currentBreakpointLabel];
        const isDifferent = currentValue !== acc.previousValue;
        return {
            ...acc,
            collapsedBreakpoints: {
                ...acc.collapsedBreakpoints,
                ...(isDifferent && {
                    [currentBreakpointLabel]: breakpoints[currentBreakpointLabel],
                }),
            },
            ...(isDifferent && {
                previousBreakpointLabel: currentBreakpointLabel,
                previousValue: currentValue,
            }),
        };
    }, {
        collapsedBreakpoints: { [firstBreakpointLabel]: firstValue },
        previousBreakpointLabel: firstBreakpointLabel,
        previousValue: firstValue,
    });
    return isEqual(Object.keys(collapsedBreakpoints), ['xs'])
        ? collapsedBreakpoints.xs
        : collapsedBreakpoints;
};
const mapStyleValueForBreakpoint = (styleValue, breakpointLabel) => {
    switch (typeof styleValue) {
        case 'function':
            return styleValue(breakpointLabel);
        case 'object':
            return styleValue[breakpointLabel];
        default:
            return styleValue;
    }
};
export const responsiveStyles = (styles, breakpointLabels) => {
    const unoptimizedBreakpointStyles = mapValues(styles, (styleValue) => Object.keys(breakpointLabels).reduce((breakpoints, breakpointLabel) => ({
        ...breakpoints,
        [breakpointLabel]: mapStyleValueForBreakpoint(styleValue, breakpointLabel),
    }), {}));
    const collapsedBreakpointStyles = mapValues(unoptimizedBreakpointStyles, collapseBreakpoints);
    const simpleStyles = pickBy(collapsedBreakpointStyles, isScalar);
    const breakpointStyles = omitBy(collapsedBreakpointStyles, isScalar);
    return [
        ...Object.entries(simpleStyles).map(([styleRule, styleValue]) => `${styleRule}:${styleValue};`),
        ...Object.entries(breakpointLabels)
            .filter(([breakpointLabel]) => Object.entries(breakpointStyles).some(([, breakpoints]) => !!breakpoints[breakpointLabel]))
            .map(([breakpointLabel, minWidth]) => {
            const serializedStyles = Object.entries(breakpointStyles)
                .filter(([, breakpoints]) => Boolean(breakpoints[breakpointLabel]))
                .map(([styleRule, breakpoints]) => `${styleRule}:${breakpoints[breakpointLabel]};`)
                .join('');
            return `@media (min-width:${minWidth}px) {${serializedStyles}}`;
        }),
    ].join('');
};
//# sourceMappingURL=responsiveStyles.js.map